import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";

const BlogCard = ({ blog }) => {
  return (
    <Link
      to={blog.url}
      className="relative rounded-2xl border border-gray-200 p-4 text-left shadow-sm transition duration-500 hover:scale-105 hover:shadow-md hover:transition-transform"
    >
      <img
        src={blog.image}
        alt={blog.title}
        className="mb-4 h-48 w-full rounded-xl object-cover"
      />
      <div className="pb-12">
        <h3 className="text-dark mb-2 line-clamp-2 text-lg font-semibold">
          {blog.title}
        </h3>
        <p className="text-gray mb-4 line-clamp-3 text-sm">
          {blog.description}
        </p>
      </div>

      <div className="text-gray absolute right-4 bottom-4 left-4 flex items-center justify-between text-sm">
        <div className="flex items-center gap-2">
          <img
            src={blog.author.image}
            alt={blog.author.name}
            className="h-8 w-8 rounded-full"
          />
          <span>{blog.author.name}</span>
        </div>
        <div className="flex items-center gap-1">
          <FaEye className="text-primary" />
          <span>{blog.category}</span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
